<template>
    <b-form-group :label="$t('space')" label-id="WTB-Konfig-label-1">
        <div class="d-flex gap-2">
            <div class="width-max-600 flex-grow-1">
                <MultiselectSpaces
                    id="filter-space"
                    label-id="WTB-Konfig-label-1"
                    :value="parentComponent.filtersParams.space"
                    :show-checkboxes="false"
                    :multiple="false"
                    :close-on-select="true"
                    :clear-on-select="true"
                    :disabled="parentComponent.loading"
                    :placeholder="$t('selectField.placeholder')"
                    @inputTrackBy="parentComponent.filters.space = $event"
                />
            </div>
            <ButtonIcon :disabled="parentComponent.loading" @click="parentComponent.filterData()">{{ $t('filter') }}</ButtonIcon>
        </div>
    </b-form-group>
</template>



<script>
    import MultiselectSpaces from '@/components/common/MultiselectSpaces.vue';

    export default {
        name: 'Filters',
        components: {
            MultiselectSpaces,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
    };
</script>
